export const FOUNDERS = [
  {
    name: 'Hunter Kauffman',
    email: 'support@servesynctennis.com',
    role: 'Cofounder',
  },
  {
    name: 'Cam Malone',
    email: 'cam@servesynctennis.com',
    role: 'Cofounder',
  },
  {
    name: 'Austin Eames',
    email: 'austin@servesynctennis.com',
    role: 'Cofounder',
  },
]
